import { StockCard } from './StockCard';
import type { StockScore } from '../types/api';
import { Loader2 } from 'lucide-react';

interface StockGridProps {
  stocks: StockScore[];
  isLoading?: boolean;
  onStockClick?: (stock: StockScore) => void;
}

export function StockGrid({ stocks, isLoading, onStockClick }: StockGridProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (stocks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <div className="text-slate-400 text-lg mb-2">No stocks found</div>
        <p className="text-slate-500 text-sm">Try adjusting your filters or search query</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {stocks.map((stock) => (
        <StockCard 
          key={stock.id} 
          stock={stock} 
          onClick={() => onStockClick?.(stock)}
        />
      ))}
    </div>
  );
}

